import { createSlice } from "@reduxjs/toolkit";

const pickDetailSlice = createSlice({
  name: "pickDetail",
  initialState: {
    loading: false,
    error: false,
    fixtures: [],
  },
  reducers: {
    updateLoadingStatus: (state, action) => {
      state.loading = action.payload;
    },
    updateErrStatus: (state) => {
      state.loading = false;
      state.error = true;
    },
    fetchFixtures: (state, action) => {
      state.loading = false;
      state.error = false;
      state.fixtures = action.payload;
    },
    updateLiveFixtureSocket: (state, action) => {
      const {
        awayteam_goal,
        fixture_id,
        hometeam_goal,
        status,
      } = action.payload;

      const oldFixtures = JSON.parse(JSON.stringify(state.fixtures));
      let updatedFixtures = oldFixtures.map((ele) => {
        if (ele.fixture_id === fixture_id) {
          return {
            ...ele,
            awayteam_goal: awayteam_goal,
            hometeam_goal: hometeam_goal,
            status,
            result: "None"
          };
        }
        return ele;
      });
      state.fixtures = updatedFixtures;
    },
  },
});

export const {
  updateLoadingStatus,
  updateErrStatus,
  fetchFixtures,
  updateLiveFixtureSocket,
} = pickDetailSlice.actions;

export default pickDetailSlice.reducer;
